import axios from "axios";
import { ServiceApi } from '../../utils/auth'

import helpers from "@/services/helpers";
export default {
  namespaced: true,
  state: {
    data: [],
    points: [],
    pointsTable: [],
    loading: false,
    error: null,
  },
  getters: {
    data: state => state.data,
    getPointsGenerated: state => state.points,
    getPointsGeneratedTable: state => state.pointsTable,
    homeLoading: (state) => state.loading,
  },
  mutations: {
    setData(state, payload) {
      state.data = payload.data;
    },
    SET_POINTS_GENERATED_TABLE(state, payload){
      state.pointsTable = payload.data
    },
    setPoints(state, payload) {
      state.points = payload.data;
    },
    homeBegin(state) {
      state.loading = true
    },
    homeSuccess(state) {
      state.loading = false
    },
    homeErr(state, err) {
      state.loading = false
      state.error = err
    },
  },
  actions: {
    async fetchPointsGenerated({ commit }, payload) {
      commit('homeBegin')
      try {
        const res = await axios.get(`/api/generated-points`);
        commit("setPoints", res.data);
        commit('homeSuccess', true)
        return res.data;
      } catch (error) {
        commit('homeErr', error)
        return error
      }
    },
    async getData({ commit }, payload) {
      commit('homeBegin')
      try {
        const res = await axios.get(`/api/search_company_product?search=${payload}`);
        commit("setData", res.data);
        commit('homeSuccess', true)
        return res.data;
      } catch (error) {
        commit('homeErr', error)
        return error
      }
    },
    async getCountryCompany({ commit }) {
      commit('homeBegin')
      try {
        const res = await axios.get('/api/countries-with-companies');
        commit("setData", res.data);
        commit('homeSuccess', true)
        return res.data;
      } catch (error) {
        commit('homeErr', error)
        return error
      }
    },

    async fetchPointsGeneratedTable({ commit }, payload) {
      commit('homeBegin')
      try {
        const res = await ServiceApi.get('/api/generated-points-table', payload);
        commit("SET_POINTS_GENERATED_TABLE", res.data);
        commit('homeSuccess', true)
        return res.data;
      } catch (error) {
        commit('homeErr', error)
        return error
      }
    }
  }
};
